import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StateView } from "../components/StateView";
import { useAuth } from "../contexts/AuthContext";

export function UnauthorizedPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);
  const [error, setError] = useState("");

  async function switchIdentity() {
    setSigningOut(true);
    setError("");
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch {
      setError("Could not end this session. Please try again.");
      setSigningOut(false);
    }
  }

  return (
    <StateView
      eyebrow="Owner access required"
      title="Reports stay with the owner."
      action={
        <button
          className="primary-button"
          disabled={signingOut}
          onClick={() => void switchIdentity()}
          type="button"
        >
          {signingOut ? "Signing out…" : "Sign in with another identity"}
        </button>
      }
    >
      <p>
        This identity is not recorded as an owner of a shop. Managers and
        cashiers can continue using the TillFlo POS.
      </p>
      <a className="inline-link" href="https://app.tillflo.co.ke">
        Return to the POS
      </a>
      {error ? <p className="error-copy">{error}</p> : null}
    </StateView>
  );
}
